class DataOptions {
    _map = {};
    _parentMap = {};

    constructor(options) {
        for (const option of options) {
            this.setOption(option);
        }
    }
    setOptions(options) {
        for (const option of options) {
            this.setOption(option);
        }
    }
    setOption(option) {
        const key = option.value;
        this._map[key] = option;
        if (option.children) {
            for (const child of option.children) {
                this._parentMap[child.value] = key;
                this.setOption(child);
            }
        }
    }

    getOptionLabel(value, showLastLevel) {
        const data = this._map[value];
        if (data == null) return value;
        if (showLastLevel) return data.label;
        const path = [data.label];
        let key = this._parentMap[value];
        while (key) {
            path.unshift(this._map[key].label);
            key = this._parentMap[key];
        }
        return path.join('/');
    }

    getOptionsTags(values) {
        if (!(values instanceof Array)) values = [values];
        const datas = [];
        for (const value of values) {
            const data = this._map[value];
            if (data) datas.push(data);
        }
        return datas;
    }
}

export default DataOptions;